import { render } from "./ModelSpareParts.vue?vue&type=template&id=e9d8b244"
import script from "./ModelSpareParts.vue?vue&type=script&lang=js"
export * from "./ModelSpareParts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__